module.exports = __webpack_public_path__ + "img/logo-reserva_palmeiras.6e45d243.svg";